import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
// import DatePicker from "react-datepicker";
import { IoMdDownload, IoIosArrowBack, IoIosClose } from "react-icons/io"
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const SalesFeePage = () => {
    // const [startDate, setStartDate] = useState(new Date());
    // const [endDate, setEndDate] = useState(new Date());
    const fileName = 'Service Fees Report Source Data (Monthly)-857';
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const userData = JSON.parse(localStorage.getItem('userData'));
    const history = useHistory();
    const [salesFee, setSalesFee] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    // excel  headers
    const excelColumns = [
        {
            Header: "DISTRIBUTOR NAME",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
        },
        {
            Header: "DISTRIBUTION LOCATION STATE",
            accessor: "DistributionLocationState",
            filter: "DistributionLocationState",
            sortType: "basic",
        },
        {
            Header: "REPORT DATE",
            accessor: "ReportDate",
            filter: "ReportDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "DEBIT MEMO#",
            accessor: "DebitMemoNum",
            filter: "DebitMemoNum",
            sortType: "basic",
        },
        {
            Header: "CB CUST ID# ",
            accessor: "CustID",
            filter: "CustID",
            sortType: "basic",
        },
        {
            Header: "CB CUST PHS ID# (For applicable CBs only)",
            accessor: "CustPHSID",
            filter: "CustPHSID",
            sortType: "basic",
        },
        {
            Header: "CB CUST NAME",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
            width:350
        },
        {
            Header: "CB CUST ADDRESS ",
            accessor: "CustAddress",
            filter: "CustAddress",
            sortType: "basic",
            width:180
        },
        {
            Header: "CB CUST CITY ",
            accessor: "CustCity",
            filter: "CustCity",
            sortType: "basic",
        },
        {
            Header: "CB CUST STATE ",
            accessor: "CustState",
            filter: "CustState",
            sortType: "basic",
        },
        {
            Header: "CB CUST ZIP",
            accessor: "CustZip",
            filter: "CustZip",
            sortType: "basic",
        },
        {
            Header: "CB CUSTOMER'S INVOICE#",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
        },
        {
            Header: "CB CUSTOMER'S INVOICE DATE",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "CONTRACT REFERENCE ",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
        },
        {
            Header: "PRODUCT NDC-11",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
        },
        {
            Header: "PRODUCT DESCRIPTION",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
            width:300
        },
        {
            Header: "SALE QTY number of bottles",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
        },
        {
            Header: "SALE QTY UOM (bottles)",
            accessor: "SaleQTYUOM",
            filter: "SaleQTYUOM",
            sortType: "basic",
        },
        {
            Header: "DOSAGE / UNITS tabs=30(tabs) liq=8 (oz)",
            accessor: "DosagORUnitstabs30",
            filter: "DosagORUnitstabs30",
            sortType: "basic",
        },
        {
            Header: "DOSAGE / UNITS",
            accessor: "DosageORUnitsUMO",
            filter: "DosageORUnitsUMO",
            sortType: "basic",
        },
        {
            Header: "Total count: tabs/tabs sol/bottles",
            accessor: "Totalcount",
            filter: "Totalcount",
            sortType: "basic",
        },
        {
            Header: "ACQUISITION COST per  unit (tabs/tab) (sol/8oz bottle)",
            accessor: "AcquisitionCost",
            filter: "AcquisitionCost",
            sortType: "basic",
        },
        {
            Header: "CONTRACT PRICE per unit ",
            accessor: "ContractPrice",
            filter: "ContractPrice",
            sortType: "basic",
        },
        {
            Header: "ADM FEES:  $40  TABLETS (first 30)",
            accessor: "ADMFees40",
            filter: "ADMFees40",
            sortType: "basic",
        },
        {
            Header: "ADM FEES:   $5  TABLETS (30 +)",
            accessor: "ADMFees5",
            filter: "ADMFees5",
            sortType: "basic",
        },
        {
            Header: "ADM FEES:   $70     LIQUID (First 8oz)",
            accessor: "ADMFees70",
            filter: "ADMFees70",
            sortType: "basic",
        },
        {
            Header: "ADM FEES:   $30     LIQUID (8oz+)",
            accessor: "ADMFees30",
            filter: "ADMFees30",
            sortType: "basic",
        },
        {
            Header: "CIBD Extended Amount",
            accessor: "CIBDExtendedAmount",
            filter: "CIBDExtendedAmount",
            sortType: "basic",
        }
    ];
    
    useEffect(() => {
        getSalesFees();
    }, []);

    async function getSalesFees() {
        setLoading(true);
        await _HttpServices
            // .getData("api/inbound/ServiceFeeReport")
            // .getData(`api/inbound/ServiceFeeReport?fileprocessId=${outbounddata.File_Process_ID}`)
            .getData(`Api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}`)
            .then((data) => {
            const ServiceFeeResult = data.data;
                if(ServiceFeeResult.length > 0){
                    ServiceFeeResult.map((res) => {
                      res.ReportDate = moment(res.ReportDate).format('MM/DD/YYYY');
                      res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY');
                      res.CIBDExtendedAmount = res.CIBDExtendedAmount == null ? "$0.00" :"$"+ (res.CIBDExtendedAmount * 1).toFixed(2);
                      res.ADMFees30 = res.ADMFees30 == null ? "$0.00" :"$"+ (res.ADMFees30 * 1).toFixed(2);
                      res.ADMFees70 = res.ADMFees70 == null ? "$0.00" :"$"+ (res.ADMFees70 * 1).toFixed(2);
                      res.ADMFees5 = res.ADMFees5 == null ? "$0.00" :"$"+ (res.ADMFees5 * 1).toFixed(2);
                      res.ADMFees40 = res.ADMFees40 == null ? "$0.00" :"$"+ (res.ADMFees40 * 1).toFixed(2);
                      res.ContractPrice = res.ContractPrice == null ? "$0.00" :"$"+ (res.ContractPrice * 1).toFixed(2);
                      res.AcquisitionCost = res.AcquisitionCost == null ? "$0.00" :"$"+ (res.AcquisitionCost * 1).toFixed(2);
                      res.Totalcount = res.Totalcount == null ? "0.0000" :(res.Totalcount * 1).toFixed(4);
                      res.DosagORUnitstabs30 = res.DosagORUnitstabs30 == null ? "0.0000" : (res.DosagORUnitstabs30 * 1).toFixed(4);
                      res.SaleQTY = res.SaleQTY == null ? "0.0000" :(res.SaleQTY * 1).toFixed(4);
                    })
                  }
                setSalesFee(ServiceFeeResult)
                setLoading(false);
                
            })
            .catch((e) => {
                setLoading(false);
                setHasError(true);
            });
    }
    const EditRecords = () =>{
        localStorage.setItem("salesFee",JSON.stringify(salesFee));
        history.push("/AkornServiceFeeEdit")
    }

    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Service Fees Report Source Data (Monthly)-857</h2>
                {loading ? <Loader /> : null}
                <div>
                {salesFee.length > 0 &&userData.RoleID === 1 &&
                 (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                <Button type="submit" className="ml-2" onClick={() => getExcel(excelColumns,salesFee,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
            <Row>
                <Col md={12}>
                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Service Fees Report Source Data (Monthly)-857.</p> :
                                <Fragment>
                                    {salesFee.length > 0 ? (
                                        <ReactTable columns={excelColumns} data={salesFee} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );
}

export default SalesFeePage